export default{
    disponibilidad_S: [],
    disponibilidad_M: [],
    disponibilidad_L: [],
    disponibilidad_XL: [],
    disponibilidad_MS: [],
    disponibilidad_MM: [],
    disponibilidad_ML: [],
}